import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=7030c7d2&lang=scss&scoped=true"

import exportComponent from "/home/deploy/www/data/workspace/ads_tencn-prod/ads/src/grow-team-assist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7030c7d2"]])

export default __exports__